import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import handleOpenWhatsApp from '../../../../services/whatsappService';

const AreYouReady = () => (
  <Box textAlign="center">
    <Typography variant="h4" color="primary" fontWeight={700} gutterBottom>
      ¿Listo para ser la solución que los condominios están buscando?
    </Typography>
    <Typography variant="body1" color="textSecondary" paragraph>
      Forma parte de Dr. Condominio Radio y conecta con los tomadores de decisiones que invierten diariamente en el mantenimiento y mejora de su hábitat. Hagamos que tu empresa sea el próximo gran aliado de nuestras comunidades bajo la guía del Dr. Julio César López Galea.
    </Typography>
    <Button
      variant="contained"
      color="primary"
      size="large"
      onClick={handleOpenWhatsApp}
      component="a"
      target="_blank"
      rel="noopener noreferrer"
      sx={{ mt: 2 }}
    >
      Contactar para Dr. Condominio Radio
    </Button>
    <Typography variant="body2" color="textSecondary" sx={{ mt: 3 }}>
      © TNO Network 2026 | Dr. Condominio: Tu patrimonio, nuestra prioridad. | The Content Evolution.
    </Typography>
  </Box>
);

export default AreYouReady;
